import { useGeoBasedLocale } from './useGeoLocale';

/**
 * Resolves a display currency code from an optional authoritative source
 * (e.g., a registry/event/order currency) with a fallback to the visitor's
 * browser/geo locale currency.
 *
 * Use this any time a feature needs to pick a currency for display when an
 * authoritative source may or may not be present (session vs. no-session,
 * pre-configured vs. brand-new event, etc.).
 */
export const useResolvedCurrencyCode = (authoritativeCode?: string | null): string => {
  const { currency: browserCurrency } = useGeoBasedLocale();
  return authoritativeCode ?? browserCurrency;
};
